
import { useEffect, useState, useRef } from "react";
import { motion, useInView } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/Stats.scss";

const Stats = () => {
  const [counts, setCounts] = useState({
    projects: 0,
    clients: 0,
    experience: 0,
    engineers: 0,
  });

  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, threshold: 0.3 });

  const targets = {
    projects: 500,
    clients: 1000,
    experience: 8,
    engineers: 100,
  };

  useEffect(() => {
    if (isInView) {
      const duration = 2000;
      const frameRate = 50;
      const steps = duration / frameRate;

      let step = 0;
      const interval = setInterval(() => {
        step++;
        setCounts({
          projects: Math.min(Math.floor((targets.projects / steps) * step), targets.projects),
          clients: Math.min(Math.floor((targets.clients / steps) * step), targets.clients),
          experience: Math.min(Math.floor((targets.experience / steps) * step), targets.experience),
          engineers: Math.min(Math.floor((targets.engineers / steps) * step), targets.engineers),
        });

        if (step >= steps) clearInterval(interval);
      }, frameRate);

      return () => clearInterval(interval);
    }
  }, [isInView]);

  const statsData = [
    { key: 'projects', value: counts.projects, label: 'Projects Completed', suffix: '+' },
    { key: 'clients', value: counts.clients, label: 'Happy Clients', suffix: '+' },
    { key: 'experience', value: counts.experience, label: 'Years of Experience', suffix: '+' },
    { key: 'engineers', value: counts.engineers, label: 'Expert Engineers', suffix: '+' }
  ];

  return (
    <section className="stats-section section-padding" ref={ref} aria-label="Company achievements and statistics">
      <div className="container-fluid px-4">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10 col-xl-8">

            {/* Section Title */}
            <div className="text-center mb-5">
              <h2 className="section-title fw-bold mb-3">
                Our Achievements
              </h2>
            </div>

            {/* Stats Grid */}
            <div className="row g-4 justify-content-center">
              {statsData.map((stat) => (
                <div key={stat.key} className="col-12 col-sm-6 col-lg-3">
                  <motion.div
                    className="stat-card h-100 d-flex flex-column justify-content-center align-items-center text-center p-4 rounded-4"
                    whileHover={{ y: -10 }}
                    transition={{ duration: 0.3, ease: "easeOut" }}
                    aria-label={`${stat.value}${stat.suffix} ${stat.label}`}
                  >
                    <h3 className="stat-value fw-bold mb-2">
                      {stat.value}{stat.suffix}
                    </h3>

                    <p className="stat-label mb-0 fw-medium fs-6">
                      {stat.label}
                    </p>
                  </motion.div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
